<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
    <span class="loading-message">Please wait...</span>
  </div>
</div>
